import {
  onBeforeSend,
  sanitizeFormDataPayload,
  sanitizeJSONPayload,
  handleUnauthorized
} from "./authManager";
import { DentalDotComApiAccessKey } from "../constants";
import $ from "jquery";

const handleAjaxError = (err, error_callback) => {
  if (err?.status === 401 && handleUnauthorized()) {
    return;
  }

  if (typeof error_callback === "function") {
    error_callback(err);
  }
};

export const getJson = (url, success_callback, error_callback, authNeeded) => {
  if (typeof authNeeded === "undefined") {
    authNeeded = true;
  }

  $.ajax({
    url: url,
    type: "GET",
    cache: false,
    headers: {
      apiKey: DentalDotComApiAccessKey
    },
    contentType: "application/json",
    beforeSend: authNeeded ? onBeforeSend : "",
    success: function (data) {
      success_callback(data);
    },
    error: function (err) {
      handleAjaxError(err, error_callback);
    }
  });
};

export const getBlobJson = (
  url,
  success_callback,
  error_callback,
  authNeeded
) => {
  if (typeof authNeeded === "undefined") {
    authNeeded = true;
  }

  $.ajax({
    url: url,
    type: "GET",
    cache: false,
    headers: {
      apiKey: DentalDotComApiAccessKey
    },
    contentType: "application/json",
    beforeSend: authNeeded ? onBeforeSend : "",
    xhrFields: {
      responseType: "blob" // Important: Set responseType to 'blob'
    },
    success: function (data) {
      success_callback(data);
    },
    error: function (err) {
      handleAjaxError(err, error_callback);
    }
  });
};

export const postFormData = (
  url,
  method,
  formData,
  success_callback,
  error_callback
) => {
  const sanitizedFormData = sanitizeFormDataPayload(formData);

  $.ajax({
    url: url,
    type: method,
    data: sanitizedFormData,
    cache: false,
    headers: {
      apiKey: DentalDotComApiAccessKey
    },
    contentType: false,
    processData: false,
    dataType: "json",
    beforeSend: onBeforeSend,
    success: function (data) {
      success_callback(data);
    },
    error: function (err) {
      handleAjaxError(err, error_callback);
    }
  });
};

export const postJsonData = (
  url,
  method,
  jsonData,
  success_callback,
  error_callback
) => {
  const sanitizedJsonData = sanitizeJSONPayload(jsonData);

  $.ajax({
    url: url,
    type: method,
    data: sanitizedJsonData,
    cache: false,
    headers: {
      apiKey: DentalDotComApiAccessKey
    },
    contentType: "application/json",
    processData: false,
    beforeSend: onBeforeSend,
    success: function (data) {
      success_callback(data);
    },
    error: function (err) {
      handleAjaxError(err, error_callback);
    }
  });
};
